import { Link } from "react-router-dom";

/* This example requires Tailwind CSS v2.0+ */
export default function Error404() {
  const dirWebApp = process.env.REACT_APP_DIR_PRO
  return (
      <div className="flex min-h-screen flex-col bg-primarioMira pt-16 pb-12">
        <main className="mx-auto flex w-full max-w-7xl flex-grow flex-col justify-center px-4 sm:px-6 lg:px-8">
          <div className="flex flex-shrink-0 justify-center">
            <a href={dirWebApp} className="inline-flex">
              <span className="sr-only">Your Company</span>
              <img
                className="h-36 w-auto"
                src={"./img/Logo-xl.png"} onError={(e)=> {e.target.onerror = null; e.target.src='../../img/Logo-xl.png'}}
                alt="logo"
              />
            </a>
          </div>
          <div className="py-3">
            <div className="text-center">
              <p className="text-xl font-bold text-secundario">404</p>
              <h1 className="mt-2 text-4xl font-bold text-white tracking-tight sm:text-4xl">Esta página no existe</h1>
              <p className="mt-2 text-base text-grisMira">Lo sentimos, no pudimos encontrar la página que andas buscando.</p>
              <div className="mt-6">
                <Link to={`${dirWebApp}login`} className="text-base font-bold text-secundario hover:underline">
                  Volver a inicio
                  <span aria-hidden="true"> &rarr;</span>
                </Link>
              </div>
            </div>
          </div>
        </main>
        <footer className="mx-auto w-full max-w-7xl flex-shrink-0 px-4 sm:px-6 lg:px-8">
        </footer>
      </div>
  )
}